import { useMemo } from 'react';

import { useEnv } from '@/src/application/hooks/util/useEnv';
import configData from '@/src/config.json';

import { AutomationService } from './AutomationService';
import { StubAutomationService } from './StubAutomationService';

export const useAutomationService = () => {
  const { env } = useEnv();

  const service = useMemo(() => {
    if (env !== 'storybook') {
      const { URL_EMA_APP_V2, URL_EMA_APP, JWT_DEV_TOKEN, URL_API_AUTOMATION } =
        configData.endpoints[env];
      const jwt =
        JWT_DEV_TOKEN !== ''
          ? JWT_DEV_TOKEN
          : (window as Window & typeof globalThis & { __JWTToken: string }).__JWTToken;

      return AutomationService.create({
        jwt: jwt,
        url_ema_app_v2: URL_EMA_APP_V2,
        url_ema_app_v1: URL_EMA_APP,
        url_flows_v1: URL_API_AUTOMATION,
      });
    } else {
      return StubAutomationService.create();
    }
  }, [env]);

  return service;
};
